import { IColumn, mergeStyles } from '@fluentui/react';

import { MetadataCell } from '../components/ListPages/MetadataCell';

const noField = 'no-field';

export type ProcessValueFunction = (data?: any) => any;

export const onRenderDataCell = <EntityModel,>(
  item: EntityModel,
  _?: number,
  column?: IColumn,
  processValue?: ProcessValueFunction
) => (
  <MetadataCell title={column?.name}>
    {processValue ? processValue(item[column?.fieldName || 'name']) : item[column?.fieldName || 'name']}
  </MetadataCell>
);

export const onRenderBooleanCell: typeof onRenderDataCell = <EntityModel,>(
  item: EntityModel,
  _i?: number,
  column?: IColumn
) => <MetadataCell title={column?.name}>{item[column?.fieldName || noField] ? 'Yes' : 'No'}</MetadataCell>;

export const NONE_OPTION_KEY = `__none__` as const;

const classNameNoneOption = mergeStyles({
  fontStyle: 'italic',
});

/**
 * An empty option for dropdowns or select-menus.
 */
export const noneOption = {
  key: NONE_OPTION_KEY,
  text: (<span className={classNameNoneOption}>None</span>) as unknown as string, // The ISelectableOption requires a string, but in fact, any ReactNode works and string would not allow us styling.
} as const;
